import { NavigationRuleEditComponent } from './actions/navigation-edit/navigation-edit.component';
import { NotificationRuleEditComponent } from './actions/notification-edit/notification-edit.component';
import { SetFieldValueRuleEditComponent } from './actions/set-field-value-edit/set-field-value-edit.component';

export const WorkflowRuleActionsMap = new Map<string, any>([
  [
    '6e51f319-f844-4f84-ae3f-322a57357a05',
    { component: NavigationRuleEditComponent, desc: 'MANAGEMENT.WORKFLOW.RULE-ACTION-DESC-NAVIGATION' }
  ],
  [
    'fdaee755-c7b5-4c74-a8e6-17f4cd2fae55',
    { component: SetFieldValueRuleEditComponent, desc: 'MANAGEMENT.WORKFLOW.RULE-ACTION-DESC-SET-DOC-VALUE' }
  ],
  [
    '1a07fe62-7445-4c86-a7e1-d0d01d771288',
    { component: NotificationRuleEditComponent, desc: 'MANAGEMENT.WORKFLOW.RULE-ACTION-DESC-NOTIFICATION' }
  ]
]);
